import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {UserGetSchema} from '../../../../api/DBSchema/User';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import SMCButton from '../../../../components/Simple/SMCButton';
import ShowQRModal from '../../../PopupPages/ShowQRModal';
import {useBoolean} from '../../../../utils/hooks';
import {ObjectTypes} from '../../../../api/consts';

const pageSchema = UserGetSchema.pages.twoStepAuth;
const pageId = pageSchema.pageId;

function UserTwoStepAuth({
    origUserObject,
    userObject
}) {
    const { t } = useTranslation();

    const pageData = userObject[pageId];
    const isTwoFactorAuth = pageData[pageSchema.isTwoFactorAuth];
    const twoFactorAuthQrUrl = pageData[pageSchema.twoFactorAuthQrUrl];
    
    // Take original user email, and not the current
    const userEmail = origUserObject[UserGetSchema.pages.general.pageId]?.[UserGetSchema.pages.general.email];
    const userId = userObject[UserGetSchema.id];

    const [isQRCodeModalOpen, openQRCodeModal, closeQRCodeModal] = useBoolean(false);

    return (
        <EditorLayout>
            <RowLayout spacing="6px">
                <SMCLabel inline>{t('SMP.PAGE.2FA_ENABLE')}</SMCLabel>
                {/* isTwoFactorAuth - readonly */}
                <SMCCheckbox checked={isTwoFactorAuth} disabled /> 
                <SMCButton disabled={!isTwoFactorAuth} onClick={openQRCodeModal} ignoreDisabledContext>{t('SMP.USERS.TABLE.PAGES.2FA.SHOW_QR')}</SMCButton>
            </RowLayout>
            {/* Popup windows */}
            <ShowQRModal
                isOpen={isQRCodeModalOpen}
                onRequestClose={closeQRCodeModal}
                qrLink={twoFactorAuthQrUrl}
                userEmail={userEmail}
                objectType={ObjectTypes.USER}
                userId={userId}
            />
        </EditorLayout>
    )
}

export default UserTwoStepAuth;